import { gql } from '@apollo/client';

const GET_REFUND_METHODS = gql`
  query RefundMethods($returnDetails: OrderCalculationDetails!) {
    refundMethods(returnDetails: $returnDetails) {
      merchCreditEnabled
      tmnts {
        refundHeader
      }
      refundMethods {
        id
        name
        label
        refundTotal
        returnFeeWaived
        returnShippingFee
        faultType
        headerText
        bodyText
        highlightText
        trackName
        estimatedRefundText
        displayEstimatedRefund
        orderCalculation {
          itemsRefund
          itemsRefundFmt
          exchangeAmount
          exchangeAmountFmt
          returnItemCount
          exchangeItemCount
          salesTaxRefund
          salesTaxRefundFmt
          shippingCharges
          shippingChargesFmt
          totalRefundNoShipping
          totalRefundNoShippingFmt
          totalRefund
          totalRefundFmt
        }
        titleText
        receiptHeaderText
        receiptTitleText
        receiptBodyText
        eGiftCard
        merchCredit
      }
    }
  }
`;

export default GET_REFUND_METHODS;
